<template>
  <b-card class="rounded-lg pb-5 pb-md-2">
    <report-header
      :title="$t('ledger_rep_aging')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <div class="d-flex flex-wrap mb-1">
      <b-form-input v-model="asOf" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-button size="sm" variant="primary" @click="load">{{ $t('ledger_assets_load') }}</b-button>
    </div>
    <div v-if="loading" class="text-center py-3"><b-spinner /></div>
    <template v-else-if="report">
      <div v-if="report.totals" class="ledger-num mb-1 font-weight-bold">
        {{ $t('ledger_assets_total') }} {{ money(report.totals.total) }}
      </div>
      <article v-for="customer in report.customers || []" :key="customer.customer_id" class="ledger-report-card">
        <button type="button" class="btn btn-link p-0" @click="toggle(customer.customer_id)">
          {{ customer.customer_name }}
        </button>
        <b-link class="ml-1" :to="{ name: 'ledger-customer-statement', params: { id: customer.customer_id } }">
          {{ $t('ledger_inv_statement') }}
        </b-link>
        <div class="ledger-num">{{ money(customer.total) }}</div>
        <div v-if="openId === customer.customer_id" class="small mt-50">
          <div v-for="bucket in buckets" :key="bucket">
            {{ $t(`ledger_rep_bucket_${bucket}`) }} {{ money(customer.buckets && customer.buckets[bucket]) }}
          </div>
          <div v-for="invoice in customer.invoices || []" :key="invoice.invoice_id">
            <b-link :to="{ name: 'ledger-invoices-view', params: { id: invoice.invoice_id } }">
              {{ invoice.invoice_number }}
            </b-link>
            <span class="ledger-num"> {{ money(invoice.balance_due) }}</span>
          </div>
        </div>
      </article>
    </template>
    <div v-if="report && report.totals" class="ledger-inv-sticky d-md-none">
      <span>{{ $t('ledger_assets_total') }}</span>
      <strong class="ledger-num">{{ money(report.totals.total) }}</strong>
    </div>
  </b-card>
</template>

<script>
import { BCard, BFormInput, BButton, BSpinner, BLink } from 'bootstrap-vue'
import { getArAging } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'ArAging',
  components: { BCard, BFormInput, BButton, BSpinner, BLink, ReportHeader },
  mixins: [reportMixin],
  data() {
    return { openId: null, buckets: ['not_due', '0_30', '31_60', '61_90', 'over_90'] }
  },
  mounted() { this.load() },
  methods: {
    toggle(id) {
      this.openId = this.openId === id ? null : id
    },
    async load() {
      this.loading = true
      try {
        const res = await getArAging({ as_of: this.asOf, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 11rem; }
.ledger-report-card { border-bottom: 1px solid #eee; padding: 0.65rem 0; }
.ledger-inv-sticky {
  position: fixed; bottom: 0; inset-inline: 0; z-index: 20; display: flex;
  justify-content: space-between; background: #fff; border-top: 1px solid #e6e6e6;
  padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom));
}
</style>
